// src/HimalayasRetreat2026.jsx
import React from 'react';
import { Link } from 'react-router-dom';

import himalayaIntro from './assets/himalaya_intro.jpg';
import himalay_include from './assets/himalaya_included.jpg';

import himalayaFood1 from './assets/himalaya_food1.jpg';
import himalayaFood2 from './assets/himalaya_food2.jpg';
import himalayaFood3 from './assets/himalaya_food3.jpg';
import himalayaFood4 from './assets/himalaya_food4.jpg';

import himalayaAcc1 from './assets/himalaya_accomodation1.jpg';
import himalayaAcc2 from './assets/himalaya_accomodation2.jpg';
import himalayaAcc3 from './assets/himalaya_accomodation3.jpg';

// ✅ NEW hiking + yoga images
import himalayaRiver from './assets/himalaya_river.jpg';
import himalayaWalking from './assets/himalaya_walking.jpg';
import himalayaYoga from './assets/himalaya_yoga.jpg';

const HimalayasRetreat2026 = () => {
  const foodImages = [himalayaFood1, himalayaFood2, himalayaFood3, himalayaFood4];
  const accomodationImages = [himalayaAcc1, himalayaAcc2, himalayaAcc3];

  // ✅ NEW section images
  const hikingYogaImages = [himalayaRiver, himalayaWalking, himalayaYoga];

  return (
    <div style={{ scrollBehavior: 'smooth' }}>
      {/* Section 1: Hero (2 images side-by-side) */}
      <section
        style={{
          minHeight: '100vh',
          backgroundColor: '#0b2f2f',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          padding: '1.5rem',
        }}
      >
        <div
          style={{
            maxWidth: '1200px',
            width: '100%',
            margin: '0 auto',
            position: 'relative',
          }}
        >
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
              gap: '1rem',
              alignItems: 'stretch',
            }}
          >
            <img
              src={himalayaIntro}
              alt="Himalayas Retreat Intro"
              style={{
                width: '100%',
                height: '520px',
                objectFit: 'cover',
                borderRadius: '16px',
                boxShadow: '0 10px 25px rgba(0,0,0,0.25)',
              }}
            />

            <img
              src={himalay_include}
              alt="What's included"
              style={{
                width: '100%',
                height: '520px',
                objectFit: 'cover',
                borderRadius: '16px',
                boxShadow: '0 10px 25px rgba(0,0,0,0.25)',
              }}
            />
          </div>

          <div
            style={{
              marginTop: '1rem',
              backgroundColor: 'rgba(0,0,0,0.35)',
              padding: '1.25rem 1.75rem',
              borderRadius: '14px',
              color: '#fff',
              textAlign: 'center',
            }}
          >
            <h1 style={{ margin: 0, fontSize: 'clamp(2rem, 4vw, 3rem)' }}>
              Himalayas Hiking & Yoga Retreat 2026
            </h1>
            
          </div>
        </div>
      </section>

      {/* Section 2: Intro */}
      <section
        style={{
          backgroundColor: '#F2F2F2',
          padding: '3rem 2rem',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '1.25rem',
        }}
      >
        <h2>A Journey Into Stillness</h2>

        <p style={{ maxWidth: '850px', textAlign: 'center', lineHeight: 1.7 }}>
          Step away from the everyday and journey with us into the majestic power of the Himalayan mountains.
        </p>

        <p style={{ maxWidth: '850px', textAlign: 'center', lineHeight: 1.7 }}>
          Daily yoga, hiking, healing rituals, nourishing meals, and community spirit support a journey not only
          across sacred landscapes — but deep into your own heart.
        </p>

        <p style={{ maxWidth: '850px', textAlign: 'center', lineHeight: 1.7 }}>
          The retreat is all-inclusive. We will spend four nights in an ashram and four nights at a beautiful
          Himalayan base-camp hotel. Three vegetarian or vegan meals per day will be provided.
        </p>

        <p style={{ fontStyle: 'italic', color: '#666' }}>More details coming soon.</p>
      </section>

      {/* Section 3: Food */}
      <section style={{ backgroundColor: '#0b2f2f', padding: '3rem 2rem' }}>
        <div style={{ maxWidth: '1100px', margin: '0 auto', textAlign: 'center' }}>
          <h2 style={{ color: '#fff' }}>Nourishing Food</h2>
          <p style={{ color: 'rgba(255,255,255,0.85)', marginBottom: '2rem' }}>
            Fresh vegetarian and vegan meals to support your practice and vitality.
          </p>

          <div
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
              gap: '1rem',
            }}
          >
            {foodImages.map((img, idx) => (
              <img
                key={idx}
                src={img}
                alt={`Himalaya food ${idx + 1}`}
                style={{
                  width: '100%',
                  height: '260px',
                  objectFit: 'cover',
                  borderRadius: '14px',
                }}
              />
            ))}
          </div>
        </div>
      </section>

      {/* Section 4: Accommodation */}
      <section style={{ backgroundColor: '#F2F2F2', padding: '3rem 2rem' }}>
        <div style={{ maxWidth: '1100px', margin: '0 auto', textAlign: 'center' }}>
          <h2>Accommodation</h2>
          <p style={{ maxWidth: '850px', margin: '0 auto 2rem', lineHeight: 1.7 }}>
            A balance of simple ashram living and the comfort of a Himalayan base-camp hotel, offering rest, warmth,
            and deep connection with the mountains.
          </p>

          <div
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))',
              gap: '1.25rem',
            }}
          >
            {accomodationImages.map((img, idx) => (
              <img
                key={idx}
                src={img}
                alt={`Himalaya accommodation ${idx + 1}`}
                style={{
                  width: '100%',
                  height: '300px',
                  objectFit: 'cover',
                  borderRadius: '16px',
                  boxShadow: '0 10px 25px rgba(0,0,0,0.15)',
                }}
              />
            ))}
          </div>
        </div>
      </section>

      {/* ✅ Section 5: Hiking and Yoga (NEW) */}
      <section style={{ backgroundColor: '#0b2f2f', padding: '3rem 2rem' }}>
        <div style={{ maxWidth: '1100px', margin: '0 auto', textAlign: 'center' }}>
          <h2 style={{ color: '#fff' }}>Hiking and Yoga</h2>
          <p style={{ color: 'rgba(255,255,255,0.85)', margin: '0.75rem auto 2rem', maxWidth: '900px', lineHeight: 1.7 }}>
            This retreat blends mountain hikes with grounding daily yoga. We’ll move through breathtaking
            Himalayan landscapes, then return to the mat for deep stretching, breathwork, and mindful stillness —
            supporting strength, clarity, and connection in both body and spirit.
          </p>

          <div
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
              gap: '1rem',
            }}
          >
            {hikingYogaImages.map((img, idx) => (
              <img
                key={idx}
                src={img}
                alt={`Hiking and yoga ${idx + 1}`}
                style={{
                  width: '100%',
                  height: '280px',
                  objectFit: 'cover',
                  borderRadius: '14px',
                  boxShadow: '0 10px 25px rgba(0,0,0,0.25)',
                }}
              />
            ))}
          </div>

          
        </div>
      </section>

      {/* Section 6: Register CTA */}
      <section
        style={{
          backgroundColor: '#D0F4DE',
          padding: '3rem 2rem',
          textAlign: 'center',
        }}
      >
        <div style={{ maxWidth: '850px', margin: '0 auto' }}>
          <h2 style={{ marginBottom: '0.75rem' }}>Ready to register your interest?</h2>
          <p style={{ lineHeight: 1.7, marginTop: 0 }}>
            Places are limited. Register now and we’ll follow up with dates, pricing, and the full itinerary.
          </p>

          <Link to="/himalayas-register" style={{ textDecoration: 'none' }}>
            <button
              className="register-button"
              style={{
                marginTop: '1rem',
                padding: '0.85rem 1.6rem',
                borderRadius: '10px',
                border: 'none',
                cursor: 'pointer',
                fontWeight: 'bold',
              }}
            >
              Register Now
            </button>
          </Link>
        </div>
      </section>
    </div>
  );
};

export default HimalayasRetreat2026;
